export default __webpack_public_path__ + "static/media/robot5.6ffca00b.jpg";